<template>
<modal name="leaveRecord" transition="nice-modal-fade" :pivotY="0.3">
  <div class="leave-record">
    <div class="title">
      <div class="close-button" @click="close">
        <i></i>
      </div>
    </div>
    <div class="content">
      <div>
        您当前的录音文件还未保存,关闭弹窗时是否需要保存您的录音?
      </div>
    </div>
    <div class="button-content">
      <el-button @click="closeAll()">直接关闭</el-button>
      <el-button type="primary" @click="closeAndSave()">保存并关闭</el-button>
    </div>
  </div>
</modal>
</template>

<script>
export default {
  name: 'leaveRecord',
  data() {
    return {

    }
  },
  methods: {
    close () {
      this.$modal.hide('leaveRecord');
    },
    closeAll() {
      this.$bus.emit('record_close_ing', {type: 'close'})
      this.$modal.hide('leaveRecord');
    },
    closeAndSave() {
      this.$bus.emit('record_close_ing', {type: 'save'})
      this.$modal.hide('leaveRecord');
    }
  }
}
</script>

<style lang="scss" scoped>
.leave-record {
  position: relative;
  width: 480px;
  height: 195px;
  background: #fff;
  border-radius: 3px;
  overflow: hidden;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 0 15px;
  height: 28px;
  color: #474261;
}
div.close-button {
  position: absolute;
  right: 10px;
  top: 5px;
  width: 16px;
  cursor: pointer;
}
i {
  position:relative;
  left: 7px;
  top: 2px;
  width: 2px;
  height: 15px;
  border-radius: 3px;
  background: #737596;
  transform: rotate(45deg);
  display: inline-block;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 15px;
    border-radius: 3px;
    background: #737596;
    transform: rotate(270deg);
  }
}
.content {
  margin-top: 30px;
  text-align: center;
  font-size: 13px;
  color: #666;
}
.button-content {
  display: flex;
  justify-content: space-between;
  margin: 40px 100px;

  >div {
    text-align: center;

    div {
      margin-top: 10px;
      width: 150px;
      line-height: 1.6;
      color: #bbb;
      font-size: 13px;
    }
  }

  button {
    height: 35px;
    padding-top: 10px;

    &:first-child {
      background: #EAEAF5;
      border-color: #EAEAF5;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/emodal/record/leaveRecord.vue